/**
 * @Author: Kerem Koç <keremkoc>
 * @Date:   2018-01-25T03:09:30+03:00
 * @Email:  kerem@kocapps.com
 * @Filename: scripts.js
 * @Last modified by:   keremkoc
 * @Last modified time: 2018-04-13T06:49:45+03:00
 */
(function($, root) {
  // console.log('1');
  window.rdo = { //Revolvia Design Objects
    // loadingicon: $('pageover .loading-icon'),
    // pageOver: $('pageover'),

    loaded: false,
    pagewidth: null,
    pageheight: null,
    orientation: null,
    scale: null,
    ie: false,
    isMobile: false,
    soln: false
  };

  $.onloadWithTimeout = function(callback) {
    //do the following stuff right after everything (including images ) are loaded to page, or timeout

    //after everything is loaded:
    $(window)
      .on("load", function() {

        if (!window.rdo.loaded) {
          callback();
        }

      });

    setTimeout(function() {
      if (!window.rdo.loaded) {
        callback();
      }
    }, window.rdo.timeout);

  };

  $.fn.extend({

    checkScreen: function() {

      window.rdo.pagewidth = $(this).width();
      window.rdo.pageheight = $(this).height();

      switch (true) {
        case (window.rdo.pagewidth < 577):
          window.rdo.orientation = 'smartphone';
          window.rdo.scale = .3;
          // window.rdo.carousel.timeout = 3000;
          break;
        case (window.rdo.pagewidth < 769):
          window.rdo.orientation = 'lanscape-smartphone';
          window.rdo.scale = .4;
          break;
        case (window.rdo.pagewidth < 993):
          window.rdo.orientation = 'medium';
          window.rdo.scale = .45;
          break;
        case (window.rdo.pagewidth < 1201):
          window.rdo.orientation = 'large';
          window.rdo.scale = .5;
          break;
        case (window.rdo.pagewidth < 1367):
          window.rdo.orientation = 'xlarge';
          window.rdo.scale = .6;
          break;
        default:
          window.rdo.orientation = 'xxlarge';
          window.rdo.scale = .7;
      }

      if (
        (navigator.appVersion.indexOf("MSIE 10") !== -1) // ie 10
        ||
        (!!window.MSInputMethodContext && !!document.documentMode) //ie 11
      ) {
        window.rdo.ie = true;
        $('html').addClass('ie');
      }

      if (window.rdo.pagewidth < 769) {

        $(".product-solutions .filters").hide();
        window.rdo.soln = false;

      } else {
        $(".product-solutions .filters").show();
        window.rdo.soln = true;

      }
      if (window.map) {
        if (window.rdo.pagewidth < 769) {
          window.map.setZoom(4.7);
        } else if (window.rdo.pagewidth < 993) {

          window.map.setZoom(5.8);

        } else {

          window.map.setZoom(6);

        }
      }

    }
  });

  $.killLoading = function() {
    // window.rdo.loadingicon.hide();
    // window.rdo.pageOver.hide();
    // window.rdo.loadingicon.css("z-index", window.rdo.topmostLayer - 19);
    // window.rdo.pageOver.css("z-index", window.rdo.topmostLayer - 20);
    // console.log('second thing here : everything is loaded');

  };

  $.onresizeWithTimeout = function(callback) {
    //do the following stuff right after everything (including images ) are loaded to page, or timeout

    var timeoutResize;
    timeoutResize = setTimeout(function() {
      callback();
    }, 200);

    $(window)
      .resize(function(event) {
        clearTimeout(timeoutResize);
        $(window)
          .checkScreen();
        timeoutResize = setTimeout(function() {
          callback();
        }, window.rdo.timeout);
      })
      .trigger('resize');

  };

  $(function() {
    'use strict';

    $(window).checkScreen();

    $.onloadWithTimeout(function() {
      window.rdo.loaded = true;
      // $.killLoading();
      $.correct();

      // setTimeout(function() {
      // 	//after a while, if the image is still not loaded, set it to and error placeholder!
      // 	$( "img" ).each(function() {
      //
      // 		if(!IsImageOk( $( this ), !($( this ).hasClass('loading') || !$( this ).hasClass('loaded') )  )){
      // 			$(this).addClass( "img-load-error" );
      // 			$(this).attr('src',window.rdo.imageError);
      // 		}
      //
      // 	});
      //
      //
      // },window.rdo.timeoutMax);

      // if some images are not loaded, mark them as error:

    });

    $.onresizeWithTimeout(function() {
      $(window).checkScreen();

    });
  });

})(jQuery, this);

require('./script.js');
require('./parts/correct.js');
require('./parts/collapsible.text.js');
require('./parts/search.js');
require('./parts/mobile.filter.js');
